import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentManagement = ({ payments, onProcessPayment, onDownloadInvoice }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'processing':
        return 'bg-primary/10 text-primary';
      case 'failed':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle';
      case 'pending':
        return 'Clock';
      case 'processing':
        return 'Loader';
      case 'failed':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="space-y-4">
      {payments?.map((payment) => (
        <div key={payment?.id} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-start justify-between gap-4 mb-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h4 className="font-semibold text-foreground">{payment?.campaignTitle}</h4>
                <div className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(payment?.status)}`}>
                  <Icon name={getStatusIcon(payment?.status)} size={12} />
                  <span className="capitalize">{payment?.status}</span>
                </div>
              </div>
              <p className="text-sm text-muted-foreground">{payment?.influencerName}</p>
            </div>
            <div className="text-right">
              <p className="text-xl font-bold text-foreground">{payment?.amount}</p>
              <p className="text-xs text-muted-foreground">Toplam Tutar</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Platform Komisyonu</p>
              <p className="text-sm font-medium text-foreground">{payment?.commission}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Net Ödeme</p>
              <p className="text-sm font-medium text-foreground">{payment?.netAmount}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Ödeme Tarihi</p>
              <p className="text-sm font-medium text-foreground">{payment?.date}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Ödeme Yöntemi</p>
              <p className="text-sm font-medium text-foreground">{payment?.method}</p>
            </div>
          </div>

          {payment?.escrow && (
            <div className="bg-muted rounded-lg p-3 mb-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Shield" size={16} className="text-primary" />
                <p className="text-sm font-medium text-foreground">Escrow Koruması Aktif</p>
              </div>
              <p className="text-xs text-muted-foreground">
                Ödeme, teslim edilebilirler onaylanana kadar güvenli bir şekilde tutulmaktadır.
              </p>
            </div>
          )}

          <div className="flex items-center gap-2">
            {payment?.status === 'pending' && (
              <Button
                variant="default"
                size="sm"
                iconName="CreditCard"
                iconPosition="left"
                onClick={() => onProcessPayment(payment?.id)}
              >
                Ödemeyi İşle
              </Button>
            )}
            {payment?.status === 'completed' && (
              <Button
                variant="outline"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={() => onDownloadInvoice(payment?.id)}
              >
                Faturayı İndir
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              iconName="Eye"
              iconPosition="left"
            >
              Detayları Görüntüle
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentManagement;